"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EBEnvsEnum", {
  enumerable: true,
  get: function get() {
    return _featureDetection.EBEnvs;
  }
});
Object.defineProperty(exports, "useRealUserMonitoring", {
  enumerable: true,
  get: function get() {
    return _hooks.useRealUserMonitoring;
  }
});
Object.defineProperty(exports, "realUserMonitoringReduxMiddleware", {
  enumerable: true,
  get: function get() {
    return _reduxMiddleware.realUserMonitoringReduxMiddleware;
  }
});
Object.defineProperty(exports, "addCustomRUMError", {
  enumerable: true,
  get: function get() {
    return _utils.addCustomRUMError;
  }
});
Object.defineProperty(exports, "addCustomRUMEvent", {
  enumerable: true,
  get: function get() {
    return _utils.addCustomRUMEvent;
  }
});
Object.defineProperty(exports, "initializeRealUserMonitoring", {
  enumerable: true,
  get: function get() {
    return _utils.initializeRealUserMonitoring;
  }
});
Object.defineProperty(exports, "setUser", {
  enumerable: true,
  get: function get() {
    return _utils.setUser;
  }
});

var _featureDetection = require("@eventbrite/feature-detection");

var _hooks = require("./hooks");

var _reduxMiddleware = require("./redux-middleware");

var _utils = require("./utils");
//# sourceMappingURL=index.js.map